export const ZOOM_POSTMSG = {
  /** iframe → parent: toolkit reported the user joined the live session. */
  SESSION_JOINED: 'TELEHEALTH_SESSION_JOINED',
  /** iframe → parent: toolkit reported session close (Leave clicked, host ended, etc). */
  SESSION_CLOSED: 'TELEHEALTH_SESSION_CLOSED',
  /** parent → iframe: ask the SDK to leave cleanly. Iframe will then emit SESSION_CLOSED. */
  REQUEST_LEAVE: 'TELEHEALTH_REQUEST_LEAVE',
  /** iframe → parent: the *other* participant left a still-open session.
   *  Carries a `message` string the parent surfaces as an app-level toast
   *  (e.g. "The client left the call" / "The clinician left the call"). */
  PARTICIPANT_LEFT: 'TELEHEALTH_PARTICIPANT_LEFT',
} as const

export type ZoomPostMessageType = (typeof ZOOM_POSTMSG)[keyof typeof ZOOM_POSTMSG]
